import { EvaluationCreateFormContext } from "@/components/EvaluationCreateForm/contexts/EvaluationCreateForm/EvaluationCreateFormContext";
import { useContext } from "react";

export function useEvaluationCreateForm() {
  const context = useContext(EvaluationCreateFormContext);

  if (!context) {
    throw new Error(
      "useEvaluationCreateForm should be used within the EvaluationCreateFormProvider provider."
    );
  }

  return context;
}
